module.exports = __webpack_public_path__ + "img/face-no3.d4cd22f1.png";